import React, { useState } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';

import Button from '@cosmos/button';
import Dropdown from '@cosmos/dropdown';
import {
  headerMenuRoutesMobile,
  headerMenuRoutesDesktop,
  headerRoutes,
  Route,
} from './constants';
import { sameRedirectDisabler } from '@/utils/helpers/sameRedirectDisabler';

import { headerTexts, homePageTexts, routeTexts } from '@/assets/strings';

//import CozumOrtagiLogo from '@/assets/icons/cozumortagi.svg';
//import HepsiBuradaLogo from '@/assets/icons/hepsiburada.svg';
//import IsOrtagimLogo from '@/assets/icons/isortagim.svg';

import CozumOrtagiLogo from '@/assets/icons/cozumortagi-big.svg';
import CozumOrtagiLogoMobile from '@/assets/icons/cozumortagi-big-mobile.svg';

import UserLogo from '@/assets/icons/user.svg';
import UserLogoOrange from '@/assets/icons/userOrange.svg';
import Categories from '@/assets/icons/categories.svg';

import HBBusService from 'src/services/hbBusService';
import useWindowSize, { Size } from '@/utils/hooks/useWindowSize';
import { useSelector } from 'react-redux';
import { AppState } from '@/store/store';
import { useDeviceDetect } from '@/utils/hooks/useDeviceDetect';

interface Props {
  hideButtons?: boolean;
}

const Header: React.FC<Props> = ({ hideButtons }) => {
  const router = useRouter();
  const { merchantId } = useSelector((state: AppState) => state.auth);

  const size: Size = useWindowSize();

  const currentMenu =
    size.width > 851 ? headerMenuRoutesDesktop : headerMenuRoutesMobile;
  const { username } = useSelector((state: AppState) => state.auth);
  const [menuHover, setMenuHover] = useState<boolean>(false);
  const hbBus = HBBusService();
  const { isMobile } = useDeviceDetect();

  const bePartnerClickHandler = () => {
    hbBus.signupHeaderClickEvent();
  };

  const dropdownContent = (route: Route) => {
    return (
      <a
        className='flex items-center gap-2 p-2 rounded-lg text-[#666666] text-[14px]  hover:bg-[rgba(0,0,0,0.08)] hover:text-[#ff6000]'
        target={!isMobile ? (route.blank ? '_blank' : undefined) : undefined}
        onClick={(e) =>
          sameRedirectDisabler(router, route.path, e, route.event)
        }
      >
        <Image
          src={route.icon}
          alt='handshake-logo'
          layout='fixed'
          width={20}
          height={20}
        />
        {route.label}
      </a>
    );
  };

  const onMobileDropdown = (url: string) => {
    if (url.includes('http')) {
      //@ts-ignore
      window.MerchantMobileApi.openExternalLink(url);
    }
  };

  return (
    <header>
      <div className=' lg:h-[64px] px-[18px] md:px-[25px]  md:py-3 shadow-heading flex gap-1 justify-between items-center max-w-8xl mx-auto '>
        <div className=' h-9 md:h-12 flex gap-2 justify-center md:justify-start items-center'>
          {/*<Image
            src={HepsiBuradaLogo}
            alt='hb-logo'
            layout='fixed'
            width={128}
            height={32}
          />
          <div className='h-[36px] w-[2px] bg-[#ddd]'></div>
          <Link href={routeTexts.home} passHref>
            <a
              className='mt-[6px]'
              onClick={(e) =>
                sameRedirectDisabler(router, routeTexts.home, e, {
                  buttonType: 'forward',
                  itemName: headerTexts.home,
                  location: 'Header',
                  merchantId,
                })
              }
            >
              <Image
                src={IsOrtagimLogo}
                alt='hepsiortak-logo'
                layout='fixed'
                width={90}
                height={32}
                className='cursor-pointer'
              />
            </a>
            </Link>*/}

          <div className='flex items-center'>
            <Link href={routeTexts.home} passHref>
              <a
                className='mt-[6px]'
                onClick={(e) =>
                  sameRedirectDisabler(router, routeTexts.home, e, {
                    buttonType: 'forward',
                    itemName: headerTexts.home,
                    location: 'Header',
                    merchantId,
                  })
                }
              >
                <Image
                  src={
                    size.width > 851 ? CozumOrtagiLogo : CozumOrtagiLogoMobile
                  }
                  alt='hepsiortak-logo'
                  layout='fixed'
                  width={size.width > 851 ? 228 : 78}
                  height={0}
                  className='cursor-pointer'
                />
              </a>
            </Link>
            <div className='h-[24px] w-[2px] bg-[#D9D9D9] mx-[8px]'></div>
            <p className='text-[12px] font-[500] text-[#484848]'>
              Çözüm Ortağı
            </p>
          </div>

          {size.width > 851 ? (
            <Link href={routeTexts.campaigns}>
              <a
                className=' p-2 px-3 font-[600] rounded-lg text-[#484848] hover:bg-[rgba(0,0,0,0.08)] hover:text-[#ff6000] text-[14px] flex items-center gap-2'
                onClick={(e) =>
                  sameRedirectDisabler(router, routeTexts.campaigns, e, {
                    buttonType: 'forward',
                    itemName: headerTexts.campaigns,
                    location: 'Header',
                    merchantId,
                  })
                }
              >
                <Image
                  src={Categories}
                  alt='hepsiortak-logo'
                  layout='fixed'
                  width={24}
                  height={24}
                />
                Hizmetler{' '}
              </a>
            </Link>
          ) : null}
        </div>

        <div className='flex items-center mt-2 sm:mt-0 text-[#484848] text-[14px] font-semibold mr-2 '>
          {size.width > 851 ? (
            <div>
              {headerRoutes.map((route, i) => {
                return (
                  <Link href={route.path} key={i}>
                    <a
                      className=' p-2 px-3 font-[600] text-[#484848] rounded-lg hover:bg-[rgba(0,0,0,0.08)] hover:text-[#ff6000] flex items-center gap-2'
                      onClick={(e) =>
                        sameRedirectDisabler(router, route.path, e, {
                          buttonType: 'forward',
                          itemName: headerTexts.myRequests,
                          location: 'Header',
                          merchantId,
                        })
                      }
                    >
                      <Image
                        src={route.icon}
                        alt='hepsiortak-logo'
                        layout='fixed'
                        width={24}
                        height={24}
                      />
                      {route.label}
                    </a>
                  </Link>
                );
              })}
            </div>
          ) : null}

          {hideButtons ? null : size.width > 851 ? (
            <Link href={routeTexts.signup}>
              <a onClick={bePartnerClickHandler} className='mx-2'>
                <Button size='small'>
                  <span className='text-[16px]'>{homePageTexts.bePartner}</span>
                </Button>
              </a>
            </Link>
          ) : null}
          <Dropdown
            content={
              <div className='absolute z-30 w-[200px]  bg-white left-[-139px] md:left-[-75px] mt-[-18px] md:mt-[-9px] p-2 px-3 border-2 rounded-lg drop-shadow-md font-normal	'>
                {currentMenu.map((route, i) => {
                  return typeof window !== 'undefined' &&
                    //@ts-ignore
                    typeof window.MerchantMobileApi !== 'undefined' ? (
                    <div
                      className='cursor-pointer'
                      onClick={() => onMobileDropdown(route.path)}
                      key={i}
                    >
                      {route.path?.includes('http') ? (
                        dropdownContent(route)
                      ) : (
                        <Link href={route.path} key={i}>
                          {dropdownContent(route)}
                        </Link>
                      )}
                    </div>
                  ) : (
                    <Link href={route.path} key={i}>
                      {dropdownContent(route)}
                    </Link>
                  );
                })}
              </div>
            }
            trigger={isMobile ? 'click' : 'hover'}
            contentBoxStyle={{ zIndex: 999 }}
          >
            <div
              className=' flex items-center justify-center md:justify-between gap-1 max-w-[120px] h-[64px]'
              onMouseEnter={() => setMenuHover(true)}
              onMouseLeave={() => setMenuHover(false)}
            >
              <div className='flex items-center gap-1 p-2 px-3 rounded-lg hover:bg-[rgba(0,0,0,0.08)] hover:text-[#ff6000]'>
                {menuHover ? (
                  <Image
                    src={UserLogoOrange}
                    alt='user-logo'
                    layout='fixed'
                    width={20}
                    height={20}
                  />
                ) : (
                  <Image
                    src={UserLogo}
                    alt='user-logo'
                    layout='fixed'
                    width={20}
                    height={20}
                  />
                )}
                <p className='flex gap-1 items-center text-[14px]  line-clamp-1	break-words max-w-[80px] text-[#484848]'>
                  {size.width > 851 ? username : null}{' '}
                  <span className='text-[8px] mt-[0.1rem]'>▼</span>
                </p>
              </div>
            </div>
          </Dropdown>
        </div>
      </div>
    </header>
  );
};

export default Header;
